import { getToken } from "./authHelper";


export const fetchPutResponse = (apiEndpoint,requestBody)=>{
    const apiUrl = process.env.REACT_APP_API_URL;
    return fetch(`${apiUrl}/${apiEndpoint}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(requestBody),
    });}
